module.exports = __webpack_public_path__ + "static/media/continuidad.626568d5.svg";